var $b57ee26f6a010c64$exports = {};
async function $b57ee26f6a010c64$var$loadCountryCodes() {
    try {
        const response = await fetch(`${"https://quokkalabs.com"}/blog/api/metadata?country_codes=true`);
        const data = await response.json();
        const countrySelect = document.getElementById("countryCode");
        // Clear existing options
        countrySelect.innerHTML = "";
        data.data.country_codes.forEach((country)=>{
            const option = document.createElement("option");
            option.value = country.value;
            option.textContent = country.label;
            option.dataset.code = country.value;
            option.dataset.label = country.label;
            countrySelect.appendChild(option);
        });
        // Default India selected
        countrySelect.value = "+91";
        // Show only code initially
        $b57ee26f6a010c64$var$collapseToCode();
    } catch (error) {
        console.error("Error loading country codes:", error);
    }
}
const $b57ee26f6a010c64$var$countrySelect = document.getElementById("countryCode");
function $b57ee26f6a010c64$var$restoreLabels() {
    Array.from($b57ee26f6a010c64$var$countrySelect.options).forEach((option)=>{
        option.textContent = option.dataset.label;
    });
}
function $b57ee26f6a010c64$var$collapseToCode() {
    $b57ee26f6a010c64$var$restoreLabels();
    const selectedOption = $b57ee26f6a010c64$var$countrySelect.options[$b57ee26f6a010c64$var$countrySelect.selectedIndex];
    if (selectedOption) selectedOption.textContent = selectedOption.dataset.code;
}
// Show full list while opening
$b57ee26f6a010c64$var$countrySelect.addEventListener("mousedown", $b57ee26f6a010c64$var$restoreLabels);
// Show only code after selection
$b57ee26f6a010c64$var$countrySelect.addEventListener("change", $b57ee26f6a010c64$var$collapseToCode);
// Load dropdown
$b57ee26f6a010c64$var$loadCountryCodes();
// Usage in form submit
function $b57ee26f6a010c64$var$getCountryCode() {
    const selectedOption = $b57ee26f6a010c64$var$countrySelect.options[$b57ee26f6a010c64$var$countrySelect.selectedIndex];
    return selectedOption?.dataset.code || "";
}
// form submit function and captcha related code
// =============================================
let $b57ee26f6a010c64$var$savedCaptchaCode = "";
// CAPTCHA API LOAD
const $b57ee26f6a010c64$var$createCaptchaImage = async ()=>{
    const captchaBox = document.getElementById("captchaImage");
    if (captchaBox) captchaBox.innerHTML = '<div class="w-[9.375rem] h-[3.125rem] border border-white animate-pulse"></div>';
    try {
        const response = await fetch(`${"https://quokkalabs.com"}/blog/api/captcha`, {
            method: "GET"
        });
        if (!response.ok) throw new Error("Captcha API failed");
        const result = await response.json();
        $b57ee26f6a010c64$var$savedCaptchaCode = result.captcha_0 || "";
        if (captchaBox) captchaBox.innerHTML = `
        <img
          src="${result.image_url}"
          alt="captcha"
          class="h-[3.125rem] w-[8.375rem] object-contain rounded"
        />
      `;
    } catch (error) {
        console.error("Captcha Error:", error);
        if (captchaBox) captchaBox.innerHTML = '<div class="text-white text-xs">Captcha failed</div>';
    }
};
window.onload = ()=>$b57ee26f6a010c64$var$createCaptchaImage();
window.createCaptchaImage = $b57ee26f6a010c64$var$createCaptchaImage;
// HELPERS
const $b57ee26f6a010c64$var$focusField = (id)=>{
    const el = document.getElementById(id);
    if (el) el.focus();
};
// ===============================
// VALIDATIONS
// ===============================
const $b57ee26f6a010c64$var$validateName = (name)=>{
    if (!name || name.length < 3) {
        alert("Please enter a valid full name (at least 3 characters).");
        $b57ee26f6a010c64$var$focusField("fullName");
        return false;
    }
    return true;
};
const $b57ee26f6a010c64$var$validateEmail = (email)=>{
    if (!email) {
        alert("Please enter your email address.");
        $b57ee26f6a010c64$var$focusField("email");
        return false;
    }
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!pattern.test(email)) {
        alert("Please enter a valid email address (e.g. name@example.com).");
        $b57ee26f6a010c64$var$focusField("email");
        return false;
    }
    // Count dots in the local part (before @)
    const localPart = email.split("@")[0];
    const dotCount = (localPart.match(/\./g) || []).length;
    if (dotCount > 2) {
        alert("Please enter a valid email address (e.g. name@example.com).");
        $b57ee26f6a010c64$var$focusField("email");
        return false;
    }
    return true;
};
const $b57ee26f6a010c64$var$validatePhone = (phone)=>{
    const cleaned = phone.replace(/\D/g, "");
    if (cleaned.length < 7 || cleaned.length > 15) {
        alert("Please enter a valid phone number (7 to 15 digits) with country code.");
        $b57ee26f6a010c64$var$focusField("Phone_number");
        return null;
    }
    return cleaned;
};
const $b57ee26f6a010c64$var$validateCaptcha = ()=>{
    const captchaInput = document.getElementById("captchaInput")?.value.trim();
    if (!captchaInput) {
        alert("Please enter the CAPTCHA code shown in the image.");
        $b57ee26f6a010c64$var$focusField("captchaInput");
        return false;
    }
    return true;
};
const $b57ee26f6a010c64$var$validateMessage = (message)=>{
    const trimmedMessage = message?.trim();
    // Optional field
    if (!trimmedMessage) return true;
    if (trimmedMessage.length < 10) {
        alert("Please enter a valid message (at least 10 characters).");
        $b57ee26f6a010c64$var$focusField("message");
        return false;
    }
    return true;
};
// FORM SUBMIT
const $b57ee26f6a010c64$var$FormSubmit = async (e)=>{
    e.preventDefault();
    const submitBtn = document.getElementById("form-button");
    if (submitBtn.disabled) return;
    // Honeypot check
    const honeypot = document.getElementById("honeypot");
    if (honeypot && honeypot.value !== "") return;
    const name = document.getElementById("fullName")?.value.trim();
    const email = document.getElementById("email")?.value.trim();
    const phoneRaw = document.getElementById("Phone_number")?.value.trim();
    const companyName = document.getElementById("company_name")?.value.trim();
    const message = document.getElementById("project")?.value.trim() || "";
    const captchaInput = document.getElementById("captchaInput")?.value.trim();
    const countrySelect = document.getElementById("countryCode");
    const areaOfInterest = document.getElementById("area_of_interest")?.value || "";
    const countryCode = countrySelect?.value || "";
    // Validations
    if (!$b57ee26f6a010c64$var$validateName(name)) return;
    if (!$b57ee26f6a010c64$var$validateEmail(email)) return;
    if (!$b57ee26f6a010c64$var$validateMessage(message)) return;
    const cleanedPhone = $b57ee26f6a010c64$var$validatePhone(phoneRaw || "");
    if (!cleanedPhone) return;
    if (!$b57ee26f6a010c64$var$validateCaptcha()) return;
    submitBtn.disabled = true;
    submitBtn.textContent = "Submitting...";
    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phone", cleanedPhone);
    formData.append("company_name", companyName);
    formData.append("country_code", countryCode);
    formData.append("description", message);
    formData.append("area_of_interest", areaOfInterest);
    // Captcha API values
    formData.append("captcha_0", $b57ee26f6a010c64$var$savedCaptchaCode);
    formData.append("captcha_1", captchaInput);
    // Extra fields
    formData.append("source", "contact-us");
    formData.append("user_agent", navigator.userAgent);
    try {
        const response = await fetch(`${"https://quokkalabs.com"}/blog/api/contact-us`, {
            method: "POST",
            body: formData
        });
        if (!response.ok) throw new Error("Form failed");
        const result = await response.json();
        // Save data
        if (result?.data?.name) localStorage.setItem("contact_name", result.data.name);
        if (result?.data?.email) localStorage.setItem("contact_email", result.data.email);
        // Redirect keep same
        window.location.href = "/thankyou";
    } catch (error) {
        console.error(error);
        submitBtn.disabled = false;
        submitBtn.textContent = "Submit";
        $b57ee26f6a010c64$var$createCaptchaImage();
    }
};
window.FormSubmit = $b57ee26f6a010c64$var$FormSubmit;
// PAGE CACHE FIX
window.addEventListener("pageshow", (event)=>{
    if (event.persisted) window.location.reload();
});
// THANK YOU PAGE DATA
document.addEventListener("DOMContentLoaded", ()=>{
    const userName = document.getElementById("userName");
    const userEmail = document.getElementById("userEmail");
    if (userName) userName.textContent = localStorage.getItem("contact_name") || "No Name Found";
    if (userEmail) userEmail.textContent = localStorage.getItem("contact_email") || "No Email Found";
});


//# sourceMappingURL=adapt.3bdba603.js.map
